import React from 'react';
import { Paper, Stepper, Step, StepLabel, Typography, Divider, Grid, Collapse, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isEqual } from 'lodash';

import { createOffice, fetchOffices } from '../../store/actions/office';
import { createDepartment, fetchDepartments } from '../../store/actions/department';
import { fetchEmployee, fetchEmployeeConfigs } from '../../store/actions/employee';


import ContentHeader from '../../components/ContentHeader/ContentHeader';
import EmployeeForm from './components/Forms/EmployeeForm';
import ConfigStep from './components/ConfigStep';
import FutureApplications from './components/FutureApplications/futureApplications';


function getSteps() {
  return ['Dados pessoais', 'Configurações'];
}

function getStepContent(stepIndex, formValues, handleNewHasBlockedDevice, newHasBlockedDevice, setFormValues, allowReturn, setAllowReturn, configValues, setConfigValues, departments, offices, setSubmit, defaultValues, employeeId, history, newItemConfig, setNewItemConfig, loading,lastDepartments,lastOffices) {
  switch (stepIndex) {
    case 0:
      return (
        <Grid>
          <Collapse in appear>
            <EmployeeForm
              data={formValues}
              UpdateEmployee={() => { }}
              loading={loading}
              departments={departments || []}
              offices={offices || []}
              title="Cadastrar"
              formValues={values => setFormValues(values)}
              setSubmit={setSubmit}
              employeeId={employeeId}
              history={history}
              setNewItemConfig={type => setNewItemConfig({ ...newItemConfig, open: true, type })}
              newItemConfig={newItemConfig}
              lastDepartments={lastDepartments}
              lastOffices={lastOffices}
            />
          </Collapse>
        </Grid>
      );
    case 1:
      return (
        <Grid>
          <Collapse in appear>
            <ConfigStep
              allowReturn={allowReturn}
              setAllowReturn={value => setAllowReturn(value)}
              handleNewHasBlockedDevice={handleNewHasBlockedDevice}
              state={newHasBlockedDevice}
              configValues={configValues}
              employeeValues={formValues}
              setConfigValues={(values) => { setConfigValues(values); }}
              defaultValues={defaultValues}
              employeeId={employeeId}
              history={history}
            />
          </Collapse>
        </Grid>
      );
    default:
      return 'Uknown stepIndex';
  }
}

function Employee(props) {
  const dispatch = useDispatch();
  const departments = useSelector(state => state.department.departments);
  const offices = useSelector(state => state.office.offices);

  const [activeStep, setActiveStep] = React.useState(0);
  const [formValues, setFormValues] = React.useState({});
  const [futureApplicationsItems, setFutureApplicationsItems] = React.useState([]);
  const [defaultValues, setDefaultValues] = React.useState(null);
  const [configValues, setConfigValues] = React.useState({ ScheduleForm: {}, BankOfHoursForm: {}, RestrictionsForm: {} });
  const [allowReturn, setAllowReturn] = React.useState(true);
  const [submit, setSubmit] = React.useState(false);
  const [newHasBlockedDevice, setNewHasBlockedDevice] = React.useState({ newHasBlockedDevice: '' });
  const [lastDepartments, setLastDepartments] = React.useState();
  const [lastOffices, setLastOffices] = React.useState();

  const [loading, setLoading] = React.useState(false);

  const [isLoadingFormData, setLoadingDataStatus] = React.useState(false);


  const [newItemConfig, setNewItemConfig] = React.useState({
    open: false,
    type: null,
  });

  // const updateDepartment = () => {
  //   const departamento = departments[departments.length - 1].id
  //   setLastDepartments(departamento)
  // }

  // const updateOffice = () => {
  //   const office = offices[offices.length - 1].id
  //   setLastOffices(office)
  // }

  const handleNewHasBlockedDevice = (value) => {
    if (value == 'MOBILE_ONLY') {
      setNewHasBlockedDevice({ newHasBlockedDevice: value });
    } else if (value == 'WEB_ONLY') {
      setNewHasBlockedDevice({ newHasBlockedDevice: value });
    } else {
      setNewHasBlockedDevice({ newHasBlockedDevice: '' });
    }
  }

  const steps = getSteps();

  if (props.match.path === '/funcionarios/cadastrar' && !isEqual(defaultValues, {})) {
    setDefaultValues({});
    setFormValues({});
  }

  const fetchOnLoad = React.useRef(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (fetchOnLoad.current) {
      dispatch(fetchDepartments());
      dispatch(fetchOffices());

      if (props.match.params.id) {
        setLoading(true);
        setLoadingDataStatus(true);
        dispatch(fetchEmployee(props.match.params.id))
          .then((response) => {
            setFormValues(response);
            setLoadingDataStatus(false);
            dispatch(fetchEmployeeConfigs(props.match.params.id))
              .then((config) => {
                if (config.settingsFuture && config.settingsFuture.length) {
                  setFutureApplicationsItems(config.settingsFuture);
                }

                const defaultData = {
                  ScheduleForm: {
                    scheduleId: config.workSchedule.workScale,
                    scheduleStartDate: config.workSchedule.dtRef,
                  },
                  BankOfHoursForm: {
                    hasBankOfHours: !!config.bankHours.id,
                    initialValue: config.bankHours.initialValue,
                    dtTo: config.bankHours.dtTo,
                    dtFrom: config.bankHours.dtFrom,
                    cumulativeHoursLimit: config.bankHours.cumulativeHoursLimit,
                  },
                  RestrictionsForm: {
                    dtRef: config.restrictions.hasPhoto == false && config.restrictions.restrictByLocation == false && config.restrictions.hasRestrictDevice == false ? '' : config.restrictions.dtRef,
                    restrictByLocation: config.restrictions.restrictByLocation,
                    hasPhoto: config.restrictions.hasPhoto,
                    locations: config.restrictions.restrictByLocation && config.restrictions.restrictByLocation ? JSON.parse(config.allowedLocations).map(item => item.id) : [],
                    hasBlockedDevice: config.restrictions.hasBlockedDevice ? {
                      hasRestrictDevice: config.restrictions.hasRestrictDevice,
                      hasBlockedDevice: config.restrictions.hasBlockedDevice,
                      listBlockedDevice: config.restrictions.listBlockedDevice ? config.restrictions.listBlockedDevice : [],
                    } : {}
                  },
                };
                // console.log(defaultData)
                setLoading(false);
                setDefaultValues(defaultData);
                setConfigValues({
                  ...configValues,
                  ...defaultData,
                });
              })
              .catch(error => console.log(error));
          })
          .catch(error => console.log(error));
      }
      fetchOnLoad.current = false;
    }
    // if (newItemConfig.value){
    //   updateDepartment();
    //   updateOffice();
    // }
  });

  function handleNext() {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  }

  function handleBack() {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  }

  const refreshFutureItems = () => {
    dispatch(fetchEmployeeConfigs(props.match.params.id))
      .then((config) => {
        setFutureApplicationsItems(config.settingsFuture);
      });
  };

  const firstUpdate = React.useRef(true);
  React.useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    }
  }, [formValues]);

  React.useEffect(() => {
    if (!allowReturn) {
      setAllowReturn(true);
      handleBack();
    }
  }, [allowReturn]);

  React.useEffect(() => {
    if (submit) {
      handleNext();
      setSubmit(false);
    }
  }, [submit]);

  return (
    <div>
      <ContentHeader
        title={`${props.match.params.id ? 'Editar' : 'Cadastrar'} Funcionário`}
        subtitle={`${props.match.params.id ? 'Atualize os dados do funcionário' : 'Informe os dados para cadastrar um funcionário'}`}
      >
        {!futureApplicationsItems.length || <FutureApplications reload={refreshFutureItems} data={futureApplicationsItems} employeeId={props.match.params.id} />}
      </ContentHeader>

      <Paper elevation={2}>
        <Stepper activeStep={activeStep}>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Divider />
        <div>
          <div>
            <Grid container direction="column" style={{ padding: '24px 32px' }}>
              {
                isLoadingFormData ? (
                  <div style={{ margin: 'auto' }}>
                    <CircularProgress size={20} />
                  </div>
                ) : (
                  <Typography >
                    {getStepContent(
                      activeStep,
                      formValues,
                      handleNewHasBlockedDevice,
                      newHasBlockedDevice,
                      setFormValues,
                      allowReturn,
                      setAllowReturn,
                      configValues,
                      setConfigValues,
                      departments,
                      offices,
                      setSubmit,
                      defaultValues,
                      props.match.params.id,
                      props.history,
                      newItemConfig,
                      setNewItemConfig,
                      loading,
                      lastDepartments,
                      lastOffices
                    )}
                  </Typography>
                )
              }
            </Grid>
          </div>
        </div>
      </Paper>
      <Dialog open={newItemConfig.open}>
        <DialogTitle>{newItemConfig.type === 'cargo' ? 'Adicionar cargo' : 'Adicionar departamento'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Por favor, preencha o campo a seguir com o nome do ${newItemConfig.type === 'cargo' ? 'cargo' : 'departamento'}`}
          </DialogContentText>
          <form>
            <TextField
              autoFocus
              margin="dense"
              name="name"
              label={newItemConfig.type === 'cargo' ? 'Cargo' : 'Departamento'}
              onChange={event => setNewItemConfig({ ...newItemConfig, value: event.target.value })}
              value={newItemConfig.value}
              type="text"
              fullWidth
              required
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setNewItemConfig({ ...newItemConfig, open: false })}
          >
            CANCELAR

          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={() => {
              if (newItemConfig.type === 'cargo') {
                dispatch(createOffice({ name: newItemConfig.value }))
                  .then((response) => {
                    console.log('office',response)
                    setLastOffices(response.id)
                    dispatch(fetchOffices());
                    setNewItemConfig({ ...newItemConfig, open: false, value: '' });
                  });
              } else {
                dispatch(createDepartment({ name: newItemConfig.value }))
                  .then((response) => {
                    setLastDepartments(response.id)
                    dispatch(fetchDepartments());
                    setNewItemConfig({ ...newItemConfig, open: false, value: '' });
                  });
              }
            }}
          >
            CONFIRMAR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Employee;
